import { render, staticRenderFns } from "./ScrollableMobileFeatures.vue?vue&type=template&id=7c2cb823"
import script from "./ScrollableMobileFeatures.vue?vue&type=script&lang=js"
export * from "./ScrollableMobileFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports